import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import BaseComponent from '../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import AOLogo from '../../assets/images/ao-logo.svg';
import './Footer.scss';

// Change Footer to the appropriate name
export class Footer extends BaseComponent {
  render() {
    let accent_color = this.props.currentCompany ?
      this.props.currentCompany.accent_color : '#CD030A';
    
    let logo = AOLogo;

    const borderStyle = { borderColor: accent_color };
    
    return (
      // Replace with the appropriate HTML
      <div id="ao-footer" className="footer">
        <hr style={borderStyle}/>
        <div className="footer-container">
          <img alt="Logo" className="vendor-logo" src={logo}/>
          <p className="footer-text">
            <span>{this.textMap.poweredBy.toUpperCase()}</span>
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <span>{this.textMap.processVerification.toUpperCase()}</span>
          </p>
          <div className="link-container">
            <Link className="link privacy-policy footer-text" to="">{this.textMap.privacyPolicy.toUpperCase()}</Link>
            <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
            <Link className="link terms-and-conditions footer-text" to="">{this.textMap.termsAndConditions.toUpperCase()}</Link>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/index.js